import { useState } from 'react';

const useSteps = (max: number, min = 0) => {
  const [step, setStep] = useState(min);
  return {
    step,
    isLast: step === max,
    isFirst: step === min,
    isOneStep: max === min,
    next: () => setStep((n) => Math.min(n + 1, max)),
    back: () => setStep((n) => Math.max(n - 1, min)),
    jump: (n: number) => setStep(Math.min(Math.max(n, min), max)),
  };
};

export default useSteps;
